import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=09cc7a66&"
import script from "./Goal.vue?vue&type=script&lang=ts&"
export * from "./Goal.vue?vue&type=script&lang=ts&"
import style0 from "./Goal.vue?vue&type=style&index=0&id=09cc7a66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports